import { connect } from 'react-redux'
import { createStructuredSelector } from 'reselect'
import { requestPhoneCodes } from '../../../../actions/analytics-register'
import { selectPhoneCodes } from '../../../../reducers/analytics-register'
import { back,
    backTwoSteps,
    next,
    accountRecoverySelection,
    backToAuthenticators,
    enrollFactor,
    enrollMFA,
    finish,
    getAuthenticators,
    getLogins,
    getAccountRecovery,
    qrCodeCannotScan,
    qrCodeCannotScanNext,
    qrCodeNext,
    resendCode,
    setPassword,
    sendChallenge,
    setAuthenticator,
    setDeviceType,
    setupRecoveryPhone,
    submitVerification,
    validateActivationToken,
    verifyAuthenticatorCode,
    submitAfterVerifyAuthenticatorCodeSuccess,
    welcomeNext } from '../../../../actions/registration'
import { selectAccountRecoveryData,
    selectAccountRecoveryStatus,
    selectActiveRegistrationSession,
    selectAuthenticatorData,
    selectAuthenticatorStatus,
    selectData,
    selectErrorMessage,
    selectErrorTokenMessage,
    selectMfaRequired,
    selectPasswordStatus,
    selectQRCodeData,
    selectQRCodeStatus,
    selectRegistrationSessionTimeout,
    selectResendCodeStatus,
    selectResendSuccessMsg,
    selectSendChallengeData,
    selectSendChallengeStatus,
    selectSetupRecoveryPhoneStatus,
    selectSetupRecoveryPhoneError,
    selectStatus,
    selectStep,
    selectUserAppsData,
    selectUserAppStatus,
    selectVerifyAuthenticatorStatus,
    selectVerificationStatus } from '../../../../reducers/registration'
import { logoutOktaSession, terminateOAGSession } from '../../../../actions/application'
import { selectLogoutStatusOkta, selectLogoutStatusOAG } from '../../../../reducers/application'


const mapStateToProps = createStructuredSelector({
    accountRecoveryData: selectAccountRecoveryData,
    accountRecoveryStatus: selectAccountRecoveryStatus,
    activeRegSession: selectActiveRegistrationSession,
    authenticatorStatus: selectAuthenticatorStatus,
    dataAuthenticator: selectAuthenticatorData,
    dataQRCode: selectQRCodeData,
    dataSendChallenge: selectSendChallengeData,
    dataUser: selectData,
    dataUserApps: selectUserAppsData,
    error: selectErrorMessage,
    errorToken: selectErrorTokenMessage,
    logoutStatusOAG: selectLogoutStatusOAG,
    logoutStatusOkta: selectLogoutStatusOkta,
    mfaRequired: selectMfaRequired,
    phoneCodes: selectPhoneCodes,
    qrCodeStatus: selectQRCodeStatus,
    resendSuccessMsg: selectResendSuccessMsg,
    sendChallengeStatus: selectSendChallengeStatus,
    sessionTimeout: selectRegistrationSessionTimeout,
    setupRecoveryPhoneError: selectSetupRecoveryPhoneError,
    setupRecoveryPhoneStatus: selectSetupRecoveryPhoneStatus,
    status: selectStatus,
    stepNumber: selectStep,
    submitStatusPassword: selectPasswordStatus,
    submitStatusResendCode: selectResendCodeStatus,
    submitStatusVerification: selectVerificationStatus,
    submitStatusVerifyAuthenticatorStatus: selectVerifyAuthenticatorStatus,
    userAppsStatus: selectUserAppStatus
})

const mapDispatchToProps = dispatch => {
    return {
        changeStep: () => dispatch(next()),
        getAccountRecovery: oktaUserId => dispatch(getAccountRecovery(oktaUserId)),
        init: activationToken => dispatch(validateActivationToken({ activationToken })),
        initAuthenticators: () => dispatch(getAuthenticators()),
        initQRCode: ({ factorType, provider }) => dispatch(enrollFactor({ factorType, provider })),
        initSendChallenge: recoveryType => dispatch(sendChallenge(recoveryType)),
        initUserApps: () => dispatch(getLogins()),
        logoutOktaSession: url => dispatch(logoutOktaSession(url)),
        onAccountRecoverySelection: () => dispatch(accountRecoverySelection()),
        onAfterVerifyAuthenticatorCodeSuccess: () => dispatch(submitAfterVerifyAuthenticatorCodeSuccess()),
        onBack: () => dispatch(back()),
        onBackToAuthenticators: () => dispatch(backToAuthenticators()),
        
        onBackTwoSteps: () => dispatch(backTwoSteps()),
        onEnroll: () => dispatch(enrollMFA()),        
        onFinish: () => dispatch(finish()),
        onQRCodeCannotScan: () => dispatch(qrCodeCannotScan()),
        onQRCodeCannotScanNext: () => dispatch(qrCodeCannotScanNext()),
        onQRCodeNext: () => dispatch(qrCodeNext()),
        onRequestPhoneCodes: () => dispatch(requestPhoneCodes()),
        onResendCode: recoveryType => dispatch(resendCode(recoveryType)),
        
        onSetAuthenticator: () => dispatch(setAuthenticator()),
        onSetDeviceType: () => dispatch(setDeviceType()),
        onSetupRecoveryPhone: body => dispatch(setupRecoveryPhone(body)),
        onSubmitPassword: password => dispatch(setPassword(password)),
        onSubmitVerification: ({ passCode, recoveryType }) => dispatch(submitVerification({ passCode, recoveryType })),
        onVerifyAuthenticatorCode: ({ factorType, passCode }) => dispatch(verifyAuthenticatorCode({ factorType, passCode })),
        onWelcomeNext: () => dispatch(welcomeNext()),
        terminateOAGSession: logoutOAGSession => dispatch(terminateOAGSession(logoutOAGSession))
    }
}

export default connect(mapStateToProps, mapDispatchToProps)
